import { render } from "./professionals-records-sales.vue?vue&type=template&id=1d6a3df4&scoped=true"
import script from "./professionals-records-sales.vue?vue&type=script&lang=js"
export * from "./professionals-records-sales.vue?vue&type=script&lang=js"

import "./professionals-records-sales.vue?vue&type=style&index=0&id=1d6a3df4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6a3df4"]])

export default __exports__